const CONFIG = {
    // 开发环境配置
    development: {
      assetsPath: '/static', // 静态资源路径
      baseURL: 'http://112.253.1.72:10201', // 后台接口请求地址
      baseServerURL: 'http://112.253.1.72:10201', // 服务端渲染用内网IP后台接口请求地址
      adminURL: 'http://localhost:8891',
      shipperURL: 'http://localhost:8892',
      carrierURL: 'http://localhost:8893',
      agentURL: 'http://localhost:8894', // 经纪人系统地址
      indexURL: 'http://localhost:3000', // 主站地址
      rootDomain: '', // 根域名
      ossUploadUrl: `http://172.16.1.102:10001/oss/zhongcheyun/upload`, // 上传地址
      stsUploadUrl: `http://112.253.1.72:10201/auth/auth/sts/2_5_0/a1`,
      ossClint: `https://zhongcheyun-test.oss-cn-beijing.aliyuncs.com/`,
      ossBucket: `zhongcheyun-test`,
      ossRegion: `oss-cn-beijing`,
    },
    // 测试环境配置
    staging: {
      assetsPath: '/static', // 静态资源路径
      baseURL: 'http://112.253.1.72:10201', // 后台接口请求地址
      baseServerURL: 'http://112.253.1.72:10201', // 服务端渲染用内网IP后台接口请求地址
      adminURL: 'http://112.253.1.72:10281', // 运营端系统地址
      shipperURL: 'http://112.253.1.72:10282', // 托运人系统地址
      carrierURL: 'http://112.253.1.72:10283', // 承运人系统地址
      agentURL: 'http://112.253.1.72:10284', // 经纪人系统地址
      indexURL: 'http://112.253.1.72:10280', // 主站地址
      rootDomain: '', // 根域名
      ossUploadUrl: `http://112.253.1.72:10201/oss/zhongcheyun/upload`, // 上传地址  ossUploadUrl: `http://172.16.1.102:10001/oss/zhongcheyun/upload`, // 上传地址
      stsUploadUrl: `http://112.253.1.72:10201/auth/auth/sts/2_5_0/a1`,
      ossClint: `https://zhongcheyun-test.oss-cn-beijing.aliyuncs.com/`,
      ossBucket: `zhongcheyun-test`,
      ossRegion: `oss-cn-beijing`,
    },
    // 本地测试环境配置
    local: {
      assetsPath: '/static', // 静态资源路径
      baseURL: 'http://192.168.0.110:10201', // 后台接口请求地址
      baseServerURL: 'http://172.16.1.102:10001', // 服务端渲染用内网IP后台接口请求地址
      adminURL: 'http://localhost:8891',
      shipperURL: 'http://localhost:8892',
      carrierURL: 'http://localhost:8893',
      agentURL: 'http://localhost:8894', // 经纪人系统地址
      indexURL: 'http://localhost:3000', // 主站地址
      rootDomain: '', // 根域名
      ossUploadUrl: `http://172.16.1.102:10001/oss/zhongcheyun/upload`, // 上传地址
      stsUploadUrl: `http://112.253.1.72:10201/auth/auth/sts/2_5_0/a1`,
      ossClint: `https://zhongcheyun-test.oss-cn-beijing.aliyuncs.com/`,
      ossBucket: `zhongcheyun-test`,
      ossRegion: `oss-cn-beijing`,
    },
    // 生产环境配置
    production: {
      assetsPath: '/static', // 静态资源路径
      baseURL: 'https://api.v2.zhongcheyun.cn', // 后台接口请求地址
      baseServerURL: 'http://192.168.20.68:10001', // 服务端渲染用内网IP后台接口请求地址
      adminURL: 'https://admin.zhongcheyun.cn', // 运营端系统地址
      shipperURL: 'https://shipper.zhongcheyun.cn', // 托运人系统地址
      carrierURL: 'https://carriers.zhongcheyun.cn', // 承运人系统地址
      agentURL: 'https://agent.zhongcheyun.cn', // 经纪人系统地址
      indexURL: 'https://www.zhongcheyun.cn', // 主站地址
      rootDomain: 'zhongcheyun.cn', // 根域名
      ossUploadUrl: `https://api.v2.zhongcheyun.cn/oss/zhongcheyun/upload`, // 上传地址
      stsUploadUrl: `https://api.v2.zhongcheyun.cn/auth/auth/sts/2_5_0/qgWBTSRWyU8mZrfY`,
      ossClint: `https://zhongcheyun-client.oss-cn-beijing.aliyuncs.com/`,
      ossBucket: `zhongcheyun-client`,
      ossRegion: `oss-cn-beijing`,
    },
  }
  export default CONFIG[process.env.NODE_ENV]
  


// WEBPACK FOOTER //
// ./src/api/config.js